import React, { useState } from 'react';
import { CButton } from '../../../UI';

import './style.scss';

const ZOOM_STEP = 2.5;
const DISPLAY_STEP = 25;
const MAX_DISPLAY_PERCENT = 200;

export default React.forwardRef(({ zoomValue, minuteSize, setZoomValue }, ref) => {
    const [displayPercent, setDisplayPercent] = useState(100);

    const handleZoomIn = () => {
        if (displayPercent < MAX_DISPLAY_PERCENT) {
            setZoomValue(zoomValue + ZOOM_STEP);
        }

        setDisplayPercent((prevState) => prevState < MAX_DISPLAY_PERCENT ? (prevState + DISPLAY_STEP) : MAX_DISPLAY_PERCENT);
    };

    
    const handleZoomOut = () => {
        if (displayPercent > DISPLAY_STEP) {
            setZoomValue(zoomValue - (((minuteSize / ZOOM_STEP) > ZOOM_STEP) ? ZOOM_STEP : (zoomValue / minuteSize)));
        }

        setDisplayPercent((prevState) => prevState > DISPLAY_STEP ? (prevState - DISPLAY_STEP) : DISPLAY_STEP);
    };

    return (
        <div
            ref={ref}
            className="episodes-block-zoom-control"
        >
            <CButton
                icon="plus"
                blank
                className="episodes-block-zoom-control__button episodes-block-scrolling__button--increase"
                onClick={handleZoomIn}
            />
            <span className="episodes-block-zoom-control__value">
                {displayPercent}%
            </span>
            <CButton
                icon="minus"
                blank
                className="episodes-block-zoom-control__button episodes-block-scrolling__button--decrease"
                onClick={handleZoomOut}
            />
        </div>
    );
});
